import { http } from './config'

export default {

  getAllUserRoles: () => {
    return http.get('user_roles')
  },

  getRoleByUserId: (userId) => {
    return http.get('user_roles/roles_by_user_id/' + userId)
  },

  createRoleUser: (params) => {
    return http.post('user_roles', {
      "user_role":
        {
          user_id: params.id,
          role_id: params.role_id.id
        }
    })
  },

  removeRoleUser: (roleId) => {
    return http.delete('user_roles/' + roleId)
  },

}
